/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  var Tooltip, d3;

  Tooltip = require("imports/Tooltip");

  d3 = require("d3");

  d3.layout.cloud = require("d3.layout.cloud");

  window.WordCloudVisualization = class WordCloudVisualization {
    constructor(selector, height, width, graph_id) {
      this.draw = this.draw.bind(this);
      this.selector = selector;
      this.height = height;
      this.width = width;
      this.graph_id = graph_id;
      this.colors = ["#503ABD", "#4D2D5F"];
      this.fontSizeScale = d3.scale.log().range([10, 100]);
      this.loader_id = "word-cloud-loading-advanced-search";
      this.vis = d3.select(`#${this.selector.replace('#', '')}`).append("svg").attr("width", this.width).attr('id', this.graph_id).attr("height", this.height).append("g").attr("transform", "translate(" + this.width / 2 + "," + this.height / 2 + ")");
      this.HIDE_ON_CLICK_FONT_SIZE = 20;
      this.HIDDEN_WORD_COLOR = "white";
      this.wordsToHide = [];
      this.tooltip = Tooltip.default(`${this.graph_id}-tooltip`);
    }

    draw(words, bounds) {
      var display_idx, i, j, len, ref, results, scale;
      if (bounds) {
        scale = Math.min(this.width / Math.abs(bounds[1].x - this.width / 2), this.width / Math.abs(bounds[0].x - this.width / 2), this.height / Math.abs(bounds[1].y - this.height / 2), this.height / Math.abs(bounds[0].y - this.height / 2)) / 2;
      } else {
        scale = 1;
      }
      this.text = this.vis.selectAll("text").data(words);
      this.text.transition().duration(1000).attr("transform", function(d) {
        return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
      }).style("font-size", (d) => {
        return this.fontSizeScale(d.value) + "px";
      });
      this.text.enter().append("text").attr("id", function(d, i) {
        return i;
      }).style("font-size", (d) => {
        return this.fontSizeScale(d.value) + "px";
      }).style("font-family", '"Helvetica Neue", Helvetica').style("fill", (d) => {
        return this.colors[Math.round(Math.random())];
      }).attr("text-anchor", "middle").attr("class", "cloud-text").attr("transform", function(d) {
        return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
      }).text(function(d) {
        return d.long_display;
      // removes a word from the word cloud on a double click
      }).style("opacity", 1e-6).on("dblclick", () => {
        var fontSize, fontSizeString, indicesToRemove, selectedTextIndex, text;
        if (!d3.event.path) {
          return;
        }
        fontSizeString = d3.event.path[0].style["font-size"];
        fontSize = parseFloat(fontSizeString.split("px")[0]);
        selectedTextIndex = d3.event.path[0].id;
        // remove highlight that chrome creates on a double click
        text = d3.select(`#${this.graph_id}`).selectAll("text.cloud-text")[0][selectedTextIndex];
        text.selectSubString(0, 0);
        // if text is very small, then instead of generating a whole new word cloud
        // layout we can just hide this text
        if (fontSize <= this.HIDE_ON_CLICK_FONT_SIZE) {
          // color text white to hide it
          d3.event.path[0].style.fill = this.HIDDEN_WORD_COLOR;
          // add index to @wordsToHide, so we know to remove it if we layer do
          // generate a new word cloud layout (by dblclicking a large word)
          this.wordsToHide.push(selectedTextIndex);
          return;
        }
        // if the word is large, remove it (and all the other small words to hide)
        // and generate a new layout
        indicesToRemove = this.wordsToHide.concat([selectedTextIndex]).sort((num1, num2) => {
          return num2 - num1;
        });
        indicesToRemove.forEach((index) => {
          return this.wordlist.splice(index, 1);
        });
        // need to give word cloud a list of words in form {term: xxx, frequency: ###}, so
        // remove all the fill/rotate/style stuff that the word-cloud added
        this.wordlist = this.wordlist.map((word) => {
          return {
            term: word.long_display,
            frequency: word.value
          };
        });
        // reset params
        this.wordsToHide = [];
        // update wordcloud
        return this.update(this.wordlist);
      }).on("mouseover", () => {
        var content, textNode;
        // show tooltip
        textNode = d3.event.path[0];
        content = '<p class="main-text"><strong>' + textNode.innerHTML + '</strong></p><hr>';
        content += '<strong>Count</strong><span style="float: right;">' + this.wordlist[textNode.id].value + '</span><hr>';
        content += '<i class="aside">Double click to remove</br>from visualization</i>';
        this.tooltip.showTooltip(content, d3.event);
        // darken color
        this.hoveredColor = textNode.style.fill;
        return textNode.style.fill = d3.rgb(this.hoveredColor).darker(1);
      }).on("mouseout", () => {
        var wordHidden;
        // hide tooltip and restore color
        wordHidden = this.wordsToHide.includes(d3.event.path[0].id);
        d3.event.path[0].style.fill = wordHidden ? this.HIDDEN_WORD_COLOR : this.hoveredColor;
        return this.tooltip.hideTooltip();
      });
      this.text.transition().duration(1000).style("opacity", 1);
      this.text.exit().remove();
      this.vis.transition().delay(500).duration(750).attr("transform", "translate(" + [this.width >> 1, this.height >> 1] + ")scale(" + scale + ")");
      this.top_terms = this.wordlist.slice(0, 50);
      $('.top-terms-list').empty();
      display_idx = 1;
      ref = this.top_terms;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        $('.top-terms-list').append(`<div class='list-item'><a><li class='list-group-item'><strong>${display_idx}) ${i.text}</strong><span class='frequency'>${i.value}</span></li></a></div>`);
        results.push(display_idx += 1);
      }
      return results;
    }

    update(wordlist) {
      this.wordlist = wordlist;
      this.wordlist = this.wordlist.sort(function(a, b) {
        return b.value - a.value;
      });
      this.fontSizeScale.domain(d3.extent(this.wordlist.map(function(d) {
        return d.value;
      })));
      if (this.text) {
        this.text.remove();
      }
      return d3.layout.cloud().size([this.width, this.height]).words(this.wordlist).text(function(d) {
        return d.long_display;
      }).padding(3).rotate(function() {
        if (Math.random() * 3 > 1) {
          return 0;
        } else {
          return 90;
        }
      }).font('"Helvetica Neue", Helvetica').fontSize((d) => {
        return this.fontSizeScale(d.value);
      }).on("end", this.draw).start();
    }

  };

}).call(globalThis);
